import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { N0DES_API_PREFIX } from "@/api/domain"
import type { UserAuthSignup } from "@/api/routes/users"
import type {
  Project,
  ProjectIdParam,
  ProjectInvite,
  ProjectInviteItem,
  ProjectMember,
  ProjectRole,
  User,
  Uuid,
} from "@/types"

export type CreateProjectInviteRequest = {
  username_or_email: string
  role: ProjectRole
}

// Define a service using a base URL and expected endpoints
export const projectInvitesApi = createApi({
  reducerPath: "projectInvitesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${N0DES_API_PREFIX}project-invites`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    projectInviteGet: build.query<ProjectInviteItem[], ProjectIdParam>({
      query: ({ project_id }) => ({
        url: project_id,
      }),
    }),
    projectInvitePost: build.mutation<
      { code: Uuid },
      ProjectIdParam & CreateProjectInviteRequest
    >({
      query: (body) => ({
        url: body.project_id,
        method: "POST",
        body,
      }),
    }),

    projectInviteCodeGet: build.query<ProjectInvite, { code: Uuid }>({
      query: (params) => ({
        url: "",
        params,
      }),
    }),
    projectInviteUserCodePost: build.mutation<void, { code: Uuid }>({
      query: (params) => ({
        url: "",
        params,
        method: "POST",
      }),
    }),
    projectInviteCodePost: build.mutation<
      void,
      { code: Uuid } & UserAuthSignup
    >({
      query: (body) => ({
        url: "",
        params: {
          code: body.code,
        },
        method: "POST",
        body,
      }),
    }),
    projectInviteCodeDelete: build.mutation<void, { code: Uuid }>({
      query: (params) => ({
        url: "",
        params,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useProjectInviteGetQuery,
  useProjectInvitePostMutation,

  useProjectInviteCodeGetQuery,
  useProjectInviteUserCodePostMutation,
  useProjectInviteCodePostMutation,
  useProjectInviteCodeDeleteMutation,
} = projectInvitesApi
